import { Modal } from 'react-bootstrap';

interface Props {
  show: boolean;
  whatsappNumber: string;
  setShow: (show: boolean) => void;
}

function OrderIsAlreadyWithSellerModal({ show, whatsappNumber, setShow }: Props) {
  return (
    <Modal show={show} onHide={() => setShow(false)} centered={true} animation={false}>
      <Modal.Body className="p-4 text-center">
        <h4 className="mb-3">Seu pedido já está em atendimento com o vendedor.</h4>

        <a
          target="_blank"
          rel="noreferrer"
          className="btn btn-success"
          href={`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=Quero%20modificar%20meu%20pedido`}
        >
          Falar pelo WhatsApp
        </a>
      </Modal.Body>
    </Modal>
  );
}

export default OrderIsAlreadyWithSellerModal;
